import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { CalendarTaskEdit } from "ui/Scripts/source/models/calendarTask/calendarTaskEdit";
import { DatabaseRecordType } from "ui/Scripts/source/models/enums";
import { ICalendarTaskHandlerSave } from "ui/Scripts/source/models/calendarTaskHandler/calendarTaskHandlerSave";
import { postApiCall, getApiCall } from "./tokenService";
import { SaveSuccessItems } from "ui/Scripts/source/models/common/saveSuccessItems";
import { UnlockResult } from "../common/unlockResult";
import { UserGroupListItems } from "ui/Scripts/source/models/userGroup/userGroupListItems";
import { MobileCalendarTaskItems } from "../calendarTask/mobileCalendarTaskItems";
import { CalendarTaskListItems } from "ui/Scripts/source/models/calendarTask/calendarTaskListItems";
import { CalendarTaskPermissions } from "ui/Scripts/source/models/calendarTask/calendarTaskPermissions";

// #region CalendarTask
export const getMobileCalendarTaskItems = (startDate: number, endDate: number, filter: string, states: number[], categoryIds: string[]): Promise<MobileCalendarTaskItems> => {
    return postApiCall("api/calendartask/items", MobileCalendarTaskItems, JSON.stringify({
        startDate,
        endDate,
        filter: filter || "",
        states,
        categoryIds
    }));
};

export const unlock = (id: string, lockToCurrentUser: boolean): Promise<UnlockResult> => {
    return postApiCall<UnlockResult>(
        "api/calendartask/unlock?id=" + id + "&lockToCurrentUser=" + (lockToCurrentUser ? "true" : "false"),
        UnlockResult);
};

export const getCalendarTaskListItems = (databaseRecordType: number, recordId: string, pageSize: number, page: number): Promise<CalendarTaskListItems> => {
    return postApiCall("api/calendartask/list", CalendarTaskListItems, JSON.stringify({
        databaseRecordType,
        recordId,
        pageSize,
        page,
    }));
};

export const getCalendarTaskPermissions = (calendarTaskId: string, recordId: string, databaseRecordType: DatabaseRecordType): Promise<CalendarTaskPermissions> => {
    return getApiCall("api/calendartask/permissions?id=" + calendarTaskId + "&recordId=" + (recordId ?? null) + "&databaseRecordType=" + databaseRecordType, CalendarTaskPermissions);
};
// #endregion CalendarTask

// #region Edit
export const getCalendarTaskEdit = (calendarTaskId: string, recordId: string, databaseRecordType: DatabaseRecordType): Promise<CalendarTaskEdit> => {
    return getApiCall("api/calendartask/edit?id=" + calendarTaskId + "&recordId=" + (recordId ?? null) + "&databaseRecordType=" + databaseRecordType, CalendarTaskEdit);
};

export const saveCalendarTaskEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/calendartask/editsave", SaveSuccess, JSON.stringify(obj));
};

export const removeCalendarTask = (calendarTaskId: string): Promise<ApiSuccess> => {
    return postApiCall("api/calendartask/remove?id=" + calendarTaskId, ApiSuccess);
};

export const setCalendarTaskStartDate = (calendarTaskId: string, startDate: number): Promise<ApiSuccess> => {
    return postApiCall("api/calendartask/setstartdate?id=" + calendarTaskId + "&startDate=" + startDate, ApiSuccess);
};
// #endregion Edit

// #region Edit Handlers
export const calendarTaskEditAddHandlers = (calendarTaskId: string, handlers: ICalendarTaskHandlerSave[]): Promise<ApiSuccess> => {
    return postApiCall("api/calendartask/editaddhandlers", ApiSuccess, JSON.stringify({
        id: calendarTaskId,
        handlers
    }));
};

export const calendarTaskEditRemoveHandlers = (calendarTaskId: string, handlers: ICalendarTaskHandlerSave[]): Promise<ApiSuccess> => {
    return postApiCall("api/calendartask/editremovehandlers", ApiSuccess, JSON.stringify({
        id: calendarTaskId,
        handlers
    }));
};
// #endregion Edit Handlers

// #region Edit Attachment
export const calendarTaskEditRemoveAttachments = (data: any): Promise<ApiSuccess> => {
    return postApiCall("api/calendartask/editremoveattachments", ApiSuccess, JSON.stringify(data));
};

export const calendarTaskEditAddAttachments = (data: any): Promise<SaveSuccessItems> => {
    return postApiCall("api/calendartask/editaddattachments", SaveSuccessItems, JSON.stringify(data));
};
// #endregion Edit Attachment

// #region Select user groups
export const getUserGroupListItems = (page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean, groupType: number,
    ignoreUserGroupCodes: string[], requireUserGroupCodes: string[]): Promise<UserGroupListItems> => {
    return postApiCall("api/calendartask/getusergrouplistitems", UserGroupListItems, JSON.stringify({
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        groupType: groupType || 0,
        ignoreUserGroupCodes: ignoreUserGroupCodes || [],
        requireUserGroupCodes: requireUserGroupCodes || []
    }));
};
// #endregion Select user groups
